import { useProcessorDataContext } from '../../contexts';

export type GatewaySwitchProps<StripeProps, JustifiProps> = React.PropsWithChildren<{
  stripeContent: React.FC<StripeProps>;
  justifiContent: React.FC<JustifiProps>;
  stripeProps: StripeProps;
  justifiProps: JustifiProps;
}>;

export function GatewaySwitch<StripeProps, JustifiProps>(props: GatewaySwitchProps<StripeProps, JustifiProps>) {
  const { children, stripeContent: StripeContent, justifiContent: JustifiContent, stripeProps, justifiProps } = props;

  const { activeGateway } = useProcessorDataContext();

  return (
    <>
      {activeGateway === 'stripe' && typeof StripeContent === 'function' && (
        <StripeContent {...stripeProps}>{children}</StripeContent>
      )}
      {activeGateway === 'justifi' && typeof JustifiContent === 'function' && (
        <JustifiContent {...justifiProps}>{children}</JustifiContent>
      )}
    </>
  );
}
